import {IState, IStateService} from 'angular-ui-router';
import {ApplicationPropertyRS} from '../admin/service/applicationPropertyRS.rest';
import {RouterHelper} from '../dvbModules/router/route-helper-provider';
import ILogService = angular.ILogService;
import IPromise = angular.IPromise;
import IQService = angular.IQService;
import IStateParamsService = angular.ui.IStateParamsService;

authenticationRun.$inject = ['RouterHelper'];
/* @ngInject */
export function authenticationRun(routerHelper: RouterHelper) {
    routerHelper.configureStates(getStates(), '/start');
}

function getStates(): IState[] {
    return [
        new SerfLoginState(),
        new SerfLoginAnlaufstelleState(),
        new SerfVerifyState(),
        new SerfLocalLoginState(),
        new SerfPasswordResetState(),
        new SerfInvitedUserState(),
        new SerfPasswordChangeState(),
        new SerfStartState()
    ];
}

//STATES

export class SerfLoginState implements IState {
    name = 'login';
    template = '<authentication-view>';
    //HINWEIS: Soweit ich sehen kann koennen url navigationen mit mehr als einem einzigen slash am Anfang nicht manuell in der Adressbar aufgerufen werden?
    url = '/login?type&relayPath&userID';
}

export class SerfLoginAnlaufstelleState implements IState {
    name = 'loginanlaufstelle';
    template = '<authentication-view mode="anlaufstellepruefer">';
    url = '/loginanlaufstelle?type&relayPath';
}

export class SerfVerifyState implements IState {
    name = 'verify';
    template = '<verify-view>';
    url = '/verify?verifyBenutzer';
}

export class SerfLocalLoginState implements IState {
    name = 'locallogin';
    template = '<dummy-authentication-view flex="auto" class="overflow-scroll">';
    url = '/locallogin';
    resolve = {
        dummyLoginEnabled: readDummyLoginEnabled
    };
}

export class SerfPasswordResetState implements IState {
    name = 'passwordreset';
    template = '<password-reset-view>';
    url = '/passwordreset';

}

export class SerfInvitedUserState implements IState {
    name = 'inviteduser';
    template = '<invited-user-profile-view>';
    url = '/inviteduser?changetoken&email';
}

export class SerfPasswordChangeState implements IState {
    name = 'change';
    template = '<password-change-view>';
    url = '/change?changetoken&email';
}

export class SerfStartState implements IState {
    name = 'start';
    template = '<start-view>';
    url = '/start';
}

export class IAuthenticationStateParams implements IStateParamsService {
    relayPath: string;
    type: string;
    userID: string;
}

//PARAMS
export class IChangePasswordParams implements IStateParamsService {
    email: string;
    changetoken: string;
    lang: string;
}

export class IVerfivyParams implements IStateParamsService {
    verifyBenutzer: string;
}

readDummyLoginEnabled.$inject = ['ApplicationPropertyRS', '$state', '$q', '$log'];
/* @ngInject */
export function readDummyLoginEnabled(applicationPropertyRS: ApplicationPropertyRS, $state: IStateService, $q: IQService,
                                      $log: ILogService): IPromise<boolean> {
    return applicationPropertyRS.isDummyMode()
        .then((response: boolean) => {
            if (response === false) {
                $log.debug('page is disabled');
                $state.go('start');
            }
            return response;
        }).catch(() => {
            let deferred = $q.defer<boolean>();
            deferred.resolve(undefined);
            $state.go('login');
            return deferred.promise;
        });

}




// WEBPACK FOOTER //
// ./src/app/authentication/authentication.route.ts